function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shopping-bag",
  transform: "translate(-3 -3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11817",
  "data-name": "Path 11817",
  d: "M10.274,7.849H44.217a2.425,2.425,0,0,1,2.425,2.425V44.217a2.425,2.425,0,0,1-2.425,2.425H10.274a2.425,2.425,0,0,1-2.425-2.425V10.274a2.425,2.425,0,0,1,2.425-2.425ZM3,10.274A7.274,7.274,0,0,1,10.274,3H44.217a7.274,7.274,0,0,1,7.274,7.274V44.217a7.274,7.274,0,0,1-7.274,7.274H10.274A7.274,7.274,0,0,1,3,44.217ZM27.245,24.245c-6.695,0-12.123-6.512-12.123-14.547h4.849c0,6.221,4.049,9.7,7.274,9.7s7.274-3.477,7.274-9.7h4.849C39.368,17.733,33.94,24.245,27.245,24.245Z",
  fill: "#ac1ede",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "location-sharp",
  d: "M13.431,2.25C9.742,2.25,6.75,4.944,6.75,8.263c0,5.345,6.681,12.693,6.681,12.693s6.681-7.349,6.681-12.693C20.111,4.944,17.119,2.25,13.431,2.25Zm0,9.353A2.672,2.672,0,1,1,16.1,8.931,2.672,2.672,0,0,1,13.431,11.6Z",
  transform: "translate(14.25 23.75)",
  fill: "#ac1ede"
}));

var SvgShoppingBag = function SvgShoppingBag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.49,
    height: 48.49,
    viewBox: "0 0 48.49 48.49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingBag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-bag.6c558568.svg";
export { ForwardRef as ReactComponent };